import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

/** Abonnement Web Push (VAPID) tel que renvoyé par `pushManager.subscribe()`. */
export const pushSubscriptionSchema = z.object({
  id: z.string(),
  userId: z.string(),
  endpoint: z.string().url(),
  p256dh: z.string(),
  auth: z.string(),
  userAgent: z.string().nullable().optional(),
  deviceLabel: z.string().nullable().optional(),
  lastUsedAt: z.coerce.date(),
  createdAt: z.coerce.date(),
});

export class PushSubscriptionDto extends createZodDto(pushSubscriptionSchema) {}

/**
 * POST /notifications/push/subscribe — corps = subscription JSON du navigateur
 * (endpoint + keys.p256dh + keys.auth).
 */
export const createPushSubscriptionSchema = z.object({
  endpoint: z.string().url(),
  keys: z.object({
    p256dh: z.string().min(1),
    auth: z.string().min(1),
  }),
  deviceLabel: z.string().max(120).optional(),
});
export class CreatePushSubscriptionDto extends createZodDto(createPushSubscriptionSchema) {}

/** DELETE /notifications/push/subscribe — désinscription par endpoint. */
export const deletePushSubscriptionSchema = z.object({
  endpoint: z.string().url(),
});
export class DeletePushSubscriptionDto extends createZodDto(deletePushSubscriptionSchema) {}

/** GET /notifications/push/config — expose la clé publique VAPID au client. */
export const pushConfigSchema = z.object({
  publicKey: z.string(),
  supported: z.boolean(),
});
export class PushConfigDto extends createZodDto(pushConfigSchema) {}
